module.exports = __webpack_public_path__ + "site/img/Maps_4TaiPoMarket.cd1222f5.jpg";